module.exports = __webpack_public_path__ + "static/media/rebeca-nonato.9e937392.png";